import React from 'react';
import logo from './logo.svg';
import './App.css';
import AppRouter from './routes/router';

import "./themes/themes.css"

function App() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default App;
